import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import { profileUrl } from '../../helpers/urlBuilder';

/**
 * Table cell represents horse's pedigree
 *
 * @param {{}} props
 * @constructor
 */
const BreedingCell = props => (
    <span>
        <a
            href={profileUrl(
                'horse',
                props.rowData[props.customCell.options.sireUid],
                props.rowData[props.customCell.options.sireName]
            )}
            className="js-popupLink ui-link ui-link_table"
        >
            {props.rowData[props.customCell.options.sireName]}
            <Svg
                iconName="right"
                size="XSmall"
            />
        </a>
        <br />
        <a
            href={profileUrl(
                'horse',
                props.rowData[props.customCell.options.damUid],
                props.rowData[props.customCell.options.damName]
            )}
            className="js-popupLink ui-link ui-link_table"
        >
            {props.rowData[props.customCell.options.damName]}
            <Svg
                iconName="right"
                size="XSmall"
            />
        </a>
    </span>
);

BreedingCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default BreedingCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/BreedingCell.js